








































import { Vue, Component, Prop } from "vue-property-decorator";
import GrButton from "./GrButton.vue";

@Component({
  components: {
    GrButton,
  },
})
export default class MoreInfoButtonAndLink extends Vue {
  @Prop({ type: String, required: true })
  readonly linkText!: string;

  @Prop({ type: String, required: true })
  readonly linkColor!: string;

  @Prop({ type: String, required: true })
  readonly to!: string;
}
